import { z } from 'zod';

export type CameraMapping = z.infer<typeof cameraMappingSchema>;

export const cameraMappingSchema = z.object({
  /** ID of the camera in the Kinexon system */
  cameraId: z.string(),
  /** Optional preview URL for the camera provided by the third-party video provider */
  cameraPreviewUrl: z.string().optional(),
  /** ID of the camera in the third-party video provider */
  vendorCameraId: z.string(),
});

export type CameraSelection = z.infer<typeof cameraSelectionSchema>;

/** What a client may send when mapping cameras: our own `cameraId` is assigned server-side. */
export const cameraSelectionSchema = cameraMappingSchema.pick({
  cameraPreviewUrl: true,
  vendorCameraId: true,
});
